export { default as applyStyles } from "./applyStyles.js";
export { default as arrow } from "./arrow.js";
export { default as computeStyles } from "./computeStyles.js";
export { default as eventListeners } from "./eventListeners.js";
export { default as flip } from "./flip.js";
export { default as hide } from "./hide.js";
export { default as offset } from "./offset.js";
export { default as popperOffsets } from "./popperOffsets.js";
export { default as preventOverflow } from "./preventOverflow.js";


//////////////////
// WEBPACK FOOTER
// /var/www/24tru/releases/20230713222349/htdocs-rails/node_modules/@popperjs/core/lib/modifiers/index.js
// module id = 637
// module chunks = 0 1 2 3 5 6